import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LogoLong from './LogoLong';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';

TopNavbar.propTypes = {
  primaryLabel: PropTypes.node,
  onPrimaryClick: PropTypes.func,
  secondaryLabel: PropTypes.node,
  onSecondaryClick: PropTypes.func,
  logoHref: PropTypes.string,
  primaryHref: PropTypes.string,
  // Preview-only props for the design system; do not pass in production.
  forceScrolled: PropTypes.bool,
  staticMode: PropTypes.bool
};

export default function TopNavbar(props) {
  const {
    primaryLabel = 'View full project details',
    onPrimaryClick,
    primaryHref,
    secondaryLabel = 'Express interest',
    onSecondaryClick,
    logoHref = 'https://www.communityshare.org/',
    forceScrolled = false,
    staticMode = false
  } = props;

  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setHasScrolled(window.scrollY > 0);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      setHasScrolled(false);
    };
  }, []);

  const showStickyBar = hasScrolled || forceScrolled;

  return (
    <>
      {/* Mobile: logo-only header + scroll-triggered sticky bottom bar */}
      <div className="block md:hidden">
        <header className="w-full h-[78px] bg-cs-yellow-500 flex items-center justify-center px-4">
          <a href={logoHref} aria-label="CommunityShare home">
            <LogoLong imgClassName="h-10" />
          </a>
        </header>
        {showStickyBar && (
          <div className={classNames(
            'flex flex-col',
            staticMode ? 'w-full' : 'fixed bottom-0 left-0 right-0 z-50'
          )}>
            <button
              type="button"
              onClick={onSecondaryClick}
              className="w-full bg-cs-yellow-500 text-cs-navy-800
                         text-base font-bold leading-6
                         py-3 min-h-12 cursor-pointer
                         focus:outline-none focus-visible:ring-2 focus-visible:ring-black"
            >
              {secondaryLabel}
            </button>
            <a
              href={primaryHref}
              className="w-full bg-cs-navy-800 text-white
                         text-[17px] font-bold leading-6
                         py-3 min-h-[52px] cursor-pointer
                         flex items-center justify-center
                         focus:outline-none focus-visible:ring-2 focus-visible:ring-black"
            >
              {primaryLabel}
            </a>
          </div>
        )}
      </div>

      {/* Desktop + Tablet: full header with logo + buttons */}
      <div className="hidden md:block">
        <header className="w-full h-[78px] bg-cs-yellow-500 flex items-center justify-between pr-6">
          <a href={logoHref} aria-label="CommunityShare home">
            <LogoLong imgClassName="h-[52px] px-4" />
          </a>
          <div className="flex items-center gap-3">
            <SecondaryButton onClick={onSecondaryClick}>
              {secondaryLabel}
            </SecondaryButton>
            <PrimaryButton href={primaryHref} onClick={onPrimaryClick} role="link">
              {primaryLabel}
            </PrimaryButton>
          </div>
        </header>
      </div>
    </>
  );
}
